module.exports = __webpack_public_path__ + "static/Laundromat Place Based Billboards Specs 2026-e676fc0e89c6b5b094fadc2dbe09086e.pdf";